<template>
  <b-row>
    <b-col cols="12">
      <!-- <header /> -->
    </b-col>
    <b-col cols="12">
      <!-- <header-form/> -->
      <form-wizard-number :token="token"/>
      <!-- <form-wizard-vertical />
      <form-wizard-icon />
      <form-wizard-vertical-icon /> -->
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import FormWizardNumber from './FormWizardNumber.vue'
import HeaderForm from './Header.vue'
import {
  getPertanyaanPerekomendasi
} from '@/connection-api/master'


export default {
  components: {
    BRow,
    BCol,
    FormWizardNumber,
    HeaderForm,
  },
  data() {
    return {
      rawData: {},
    }
  },
  props: {
    token: {},
  }
}
</script>

<style lang="scss">
  @import '@core/scss/vue/libs/vue-wizard.scss';
  @import '@core/scss/vue/libs/vue-select.scss';
</style>
